import { AuthRepo } from "@/repos";
class AuthService {
    async login(username, password) {
        let { data } = await AuthRepo.login({username, password});
        return data;
    }
}

export default new AuthService();